module.exports = __webpack_public_path__ + "static/media/pastel_crayon_0-webfont.1e601e1f.ttf";